import React, { createContext } from 'react';
import { deepmerge } from '../utils/index.js';
import { copy as defaultCopy } from '../copy/index.js';
export const CopyContext = createContext({
    copy: defaultCopy,
});
export const CopyProvider = ({ children, copy = {} }) => {
    const mergedCopy = deepmerge(defaultCopy, copy);
    return (React.createElement(CopyContext.Provider, { value: { copy: mergedCopy } }, children));
};
//# sourceMappingURL=copy-context.js.map